/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Firstname2Inputs */

const en_formfields_firstname2 = /** @type {(inputs: Formfields_Firstname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First name`)
};

/**
* | output |
* | --- |
* | "First name" |
*
* @param {Formfields_Firstname2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_firstname2 = /** @type {((inputs?: Formfields_Firstname2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Firstname2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_firstname2(inputs)
});
export { formfields_firstname2 as "formFields_firstName" }